export default __webpack_public_path__ + "static/media/SAV_top_diagonal.55d91112.png";